module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "160px"
    }
  }, [_c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "销售下单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "销售下单时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderTime))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理商"
    }
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.OrderData.AgentCode) + " " + _vm._s(_vm.OrderData.AgentName) + " " + _vm._s(_vm.OrderData.AgentAddress) + " " + _vm._s(_vm.OrderData.AgentTel))])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "业务员"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.SaleEmployeeName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "换货状态"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.ReturnStatusName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下单备注"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderRemark))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "换货确认时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.ReturnTime))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100 retrunLog",
    attrs: {
      "label": "回寄快递信息"
    }
  }, [(_vm.OrderData.RetrunLogisticsName != '') ? _c('span', [_vm._v("回寄物流公司：" + _vm._s(_vm.OrderData.RetrunLogisticsName))]) : _vm._e(), _vm._v(" "), (_vm.OrderData.RetrunLogisticsCode != '') ? _c('span', [_vm._v("回寄物流单号：" + _vm._s(_vm.OrderData.RetrunLogisticsCode))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    staticClass: "w100",
    attrs: {
      "label": "换货情况"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin-left": "0px"
    },
    attrs: {
      "data": _vm.OrderData.ReturnProductInitList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "退还资源包",
      "prop": "ReturnProName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "prop": "ReturnNum"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin-left": "0px",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.OrderData.ActualProductList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "实际退还资源包",
      "prop": "ActualProName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "prop": "ActualNum"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin-left": "0px",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.OrderData.ReturnProductNewList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "已换资源包",
      "prop": "ChangeProName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "prop": "ChangeNum"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "发货状态"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.SendStatusName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "w100",
    attrs: {
      "label": "代理商历史换货"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin-left": "0px"
    },
    attrs: {
      "data": _vm.OrderData.ReturnNewHistory,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "已换资源包",
      "prop": "ChangeProName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "prop": "ChangeProNum"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "w100",
    attrs: {
      "label": "换货备注"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.ReturnRemark))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "换货图片:"
    }
  }, [_c('div', {
    attrs: {
      "id": "container-1"
    }
  }, _vm._l((_vm.changePic), function(item) {
    return _c('div', {
      attrs: {
        "id": "ImgPrev"
      }
    }, [_c('div', {
      staticClass: "post-format-content"
    }, [_c('div', {
      staticClass: "post-thumbnail"
    }, [_c('img', {
      staticClass: "attachment-thumbnail wp-post-image",
      attrs: {
        "id": "myProPic",
        "src": item
      }
    })])])])
  }))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin-bottom": "15px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.viewSure
    }
  }, [_vm._v("我知道了")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f7f6a0a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Order/Exchange/components/ExchangeViewOrder/index.vue
// module id = 1500
// module chunks = 1